import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";

import { HelmetProvider } from "react-helmet-async";
import { GTMProvider } from "@eriksdigital/gs-ga4";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";

import GlobalStyles from "./styles/GlobalStyles";

// eslint-disable-next-line
if (process.env.NODE_ENV !== "production") {
  const whyDidYouRender = require("@welldone-software/why-did-you-render");
  whyDidYouRender(React);
}

ReactDOM.render(
  <HelmetProvider>
    <GTMProvider env={process.env.REACT_APP_ENVIRONMENT || "test"}>
      <Router>
        <App />
      </Router>
      <GlobalStyles />
    </GTMProvider>
  </HelmetProvider>,
  document.getElementById("root") || document.createElement("div")
);
